var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { colors } from '../../../../../../../theme/colors';
import styled, { css } from 'styled-components';
import { MessageBulk } from '../../../../../../../components/Icon';
export var baseStyle = function (_a) {
    var $isActive = _a.$isActive;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: all 0.3s ease-in-out;\n  path {\n    fill: ", ";\n  }\n  svg {\n    width: 24px;\n    height: 24px;\n  }\n"], ["\n  transition: all 0.3s ease-in-out;\n  path {\n    fill: ", ";\n  }\n  svg {\n    width: 24px;\n    height: 24px;\n  }\n"])), function () { return ($isActive ? colors.blue6 : colors.gray6); });
};
export var ChatIcon = styled(MessageBulk)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), baseStyle);
var templateObject_1, templateObject_2;
//# sourceMappingURL=styled.js.map